var widget;

const player = new Vue({
  el: '#player',
  name: 'Player',
  delimiters: ["<%","%>"],
  data: {
    sounds: [],
    currentPlayingSoundId: undefined,
    lyricsDisplayedIndex: undefined,
  },
  methods: {
    playSound(soundToSkipTo) {
      if (this.currentPlayingSoundId === soundToSkipTo.id) {
        widget.pause();
        this.currentPlayingSoundId = undefined;
      } else {
        widget.skip(this.sounds.findIndex(function(sound) {
          return sound.id === soundToSkipTo.id;
        }));
        this.currentPlayingSoundId = soundToSkipTo.id;
      }
    },
    rewindSound() {
      widget.seekTo(0);
    },
    openLyrics(soundToShowLyrics) {
      this.lyricsDisplayedIndex = this.sounds.findIndex(function(sound) {
        return sound.id === soundToShowLyrics.id;
      });
    },
    removeLyrics() {
      this.lyricsDisplayedIndex = undefined;
    },
  }
});

var iframeElement = document.querySelector("#v-pills-tracks iframe");
if (iframeElement ) {
  widget = SC.Widget(iframeElement);
  
  let interval;
  
  function loadSoundsToVue() {
    widget.getSounds(function(sounds) {
      player.$nextTick(function() {
        player.sounds = sounds;
        if (_.every(sounds, 'title')) {
          clearInterval(interval);
        }
      });
    });
  }
  
  widget.bind(SC.Widget.Events.READY, function() {
    loadSoundsToVue();
    interval = setInterval(function() {
      loadSoundsToVue();
    }, 100);
  
    widget.bind(SC.Widget.Events.PLAY, function() {
      widget.getCurrentSound(function(currentSound) {
        if (player.currentPlayingSoundId !== currentSound.id) {
          player.currentPlayingSoundId = currentSound.id;
        }
      });
    });
  });
}

const cartForm = new Vue({
  el: '#form-cart',
  name: 'CartForm',
  delimiters: ["<%","%>"],
  created() {
    let url = "?format=json";
    if (window.location.search) {
      url = window.location.search + "&format=json"
    }
    axios.get(url).then((response) => {
      this.product = response.data.product;
      this.variants = response.data.product.variants;
      this.variant = this.variants[0];
    });
  },
  data: {
    product: undefined,
    variant: { price: undefined },
    variants: [],
  },
  components: {
    VSelect: VueSelect.VueSelect,
  },
  methods: {
    addToCart() {
      axios.post('/cart/add.js', {
        items: [
          {
            quantity: 1,
            id: this.variant.id,
          }
        ]
      }).then(() => {
        axios.get('/cart.js').then((response) => {
          topCart.cart = response.data;
        });
      });
      mainToast.text = "Article ajouté au panier";
      mainBsToast.show();
    },
  }
});

let initializedCarousel;

function goToCarouselFromHash() {
  if (window.location.hash.indexOf('carousel_page') !== -1) {
    const carousel = document.querySelector('#carousel');
    carousel.classList.remove('slide');
    const carouselPage = parseInt(window.location.hash.split('_')[2], 10);
    initializedCarousel.to(carouselPage);
    setTimeout(function() {
      carousel.classList.add('slide');
    }, 500);
  }
} 

document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('#carousel');
  initializedCarousel = new bootstrap.Carousel(carousel, {
    interval: false,
    keyboard: false,
    slide: false,
    hover: false,
    wrap: false,
  });

  carousel.addEventListener('slide.bs.carousel', function(event) {
    const pageId = '#carousel_page_' + event.from;
    document.querySelectorAll(pageId + ' iframe[src*=youtube], ' + pageId + ' iframe[src*=vimeo]').forEach((iframe) => {
      iframe.src = iframe.src;
    });
    const mainDiv = document.getElementsByTagName('main')[0];
    if (event.to > 0 && event.from > 0) {
      mainDiv.classList.add("bg-product");
    } else if (event.to === 0) {
      mainDiv.classList.remove("bg-product");
    }
    window.scrollTo(0,0);
  });

  carousel.addEventListener('slid.bs.carousel', function(event) {
    window.location.hash = event.relatedTarget.id;
    const mainDiv = document.getElementsByTagName('main')[0];
    if (event.to > 0 && event.from === 0) {
      mainDiv.classList.add("bg-product");
    }
  });

  goToCarouselFromHash();
  window.addEventListener('hashchange', goToCarouselFromHash)

  const feedbackButton = document.querySelector('#feedbackButton');
  if(feedbackButton) {
    feedbackButton.addEventListener('click', function(event) {
      event.stopPropagation();
      event.preventDefault();
      profileCarousel.chosenProduct = cartForm.product;
      initializedProfileCarousel.to(3);
      const dropdown = new bootstrap.Dropdown(document.querySelector('#dropdownProfileButton'));
      dropdown.show();
      document.querySelector('textarea[name="contact[body]"]').focus();
    });
  }
});